import { Stem, Score, StemTextExtended } from "@examspark/types";

import { getNewScoreNullable } from ".";

export const scoreTextExtended = (
  expected: StemTextExtended,
  actual: Stem.Response,
): Score => {
  const score = getNewScoreNullable();
  const { config } = expected;

  score.max = 1;
  score.isScorable = false;

  if (config?.enableCustomScoring && config.maxScore) {
    score.max = Number(config.maxScore);
  }

  return score;
};
